<script>
	export let borderRadius = '12';
	export let padding = '24';
</script>

<div class="baseContainer" style="--borderRadius: {borderRadius}px; --padding: {padding}px">
	<slot />
</div>

<style>
	.baseContainer {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: var(--borderRadius);
		padding: var(--padding);
		background: #fffeff;
		box-shadow: 0px -4px 0px var(--base-l-60) inset;
	}
</style>
